import { useSelector } from 'react-redux'
import { languages } from '../../../configs/language'
import logoFiinGateEN from '../icons/logoFiinGateEN.svg'
import logoFiinGateVI from '../icons/logoFiinGateVI.svg'

export const useLogo = () => {
  const locale = useSelector((state) => state.i18n.locale)

  return locale === languages.en ? logoFiinGateEN : logoFiinGateVI
}
